import { RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "./RouteProtector";

const SampleInspectionInitiatorsDetails = lazyWithReload(
  () =>
    import(
      "src/sampleInspection/features/details/SampleInspectionInitiatorsDetails"
    ),
);

const SampleInspectionChamberAdminDetails = lazyWithReload(
  () =>
    import(
      "src/sampleInspection/features/details/SampleInspectionChamberAdminDetails"
    ),
);

const SampleCompanyCasesAssignedDashboard = lazyWithReload(
  () =>
    import(
      "src/sampleInspection/features/dashboards/SampleCompanyCasesAssignedDashboard"
    ),
);
const CreateNewSampleInspection = lazyWithReload(
  () => import("src/sampleInspection/features/forms/CreateSampleInspection"),
);
const SampleInspectionDashboardChamberAdmin = lazyWithReload(
  () =>
    import(
      "src/sampleInspection/features/dashboards/SampleInspectionsChamberAdminDashboard"
    ),
);

const SampleCompanyCaseDetails = lazyWithReload(
  () =>
    import("src/sampleInspection/features/details/SampleCompanyCaseDetails"),
);

const EditSampleInspection = lazyWithReload(
  () => import("src/sampleInspection/features/forms/EditSampleInspection"),
);

const SampleInspectionsInitiatorsDashboard = lazyWithReload(
  () =>
    import(
      "src/sampleInspection/features/dashboards/SampleInspectionsInitiatorsDashboard"
    ),
);

const SampleInspectionSupervisoryDashboard = lazyWithReload(
  () =>
    import(
      "src/sampleInspection/features/dashboards/SampleInspectionSupervisoryDashboard"
    ),
);

export const sampleInspectionPaths: RouteObject = {
  path: "/sampleInspection",
  children: [
    ...(import.meta.env.VITE_SAMPLE_INSPECTION_ACTIVATED === "true"
      ? [
          {
            path: "sample/:sampleId/initiatorsDetails",
            element: (
              <RouteProtector
                allowedUsers={[
                  "isSampleInitiator",
                  "isSystemAdmin",
                  "isGGEAdmin",
                ]}
              >
                <SampleInspectionInitiatorsDetails />
              </RouteProtector>
            ),
          },
          {
            path: "sample/:sampleId/supervisorInitiatorsDetails",
            element: (
              <RouteProtector allowedUsers={["isSupervisorAssignee"]}>
                <SampleInspectionInitiatorsDetails />
              </RouteProtector>
            ),
          },
          {
            path: "sample/:sampleId/chamberDetails",
            element: (
              <RouteProtector allowedUsers={["isChamber"]}>
                <SampleInspectionChamberAdminDetails />
              </RouteProtector>
            ),
          },
          {
            path: "sample/chamberDashboard",
            element: (
              <RouteProtector allowedUsers={["isOrgAdmin"]}>
                <SampleInspectionDashboardChamberAdmin />
              </RouteProtector>
            ),
          },
          {
            path: "sample/create",
            element: (
              <RouteProtector allowedUsers={["isSampleInitiator"]}>
                <CreateNewSampleInspection />
              </RouteProtector>
            ),
          },
          {
            path: "sample/initiatorsDashboard",
            element: (
              <RouteProtector
                allowedUsers={[
                  "isSampleInitiator",
                  "isSystemAdmin",
                  "isGGEAdmin",
                ]}
              >
                <SampleInspectionsInitiatorsDashboard />
              </RouteProtector>
            ),
          },
          {
            path: "case/dashboard",
            element: (
              <RouteProtector allowedUsers={["isChamber"]}>
                <SampleCompanyCasesAssignedDashboard />
              </RouteProtector>
            ),
          },
          {
            path: "case/:sampleCaseId",
            element: (
              <RouteProtector
                allowedUsers={[
                  "isChamber",
                  "isSystemAdmin",
                  "isGGEAdmin",
                  "isSampleInitiator",
                  "isSupervisorAssignee",
                ]}
              >
                <SampleCompanyCaseDetails />
              </RouteProtector>
            ),
          },
          {
            path: "sample/edit/:sampleId",
            element: (
              <RouteProtector allowedUsers={["isSampleInitiator"]}>
                <EditSampleInspection />
              </RouteProtector>
            ),
          },
          {
            path: "sampleInspectionSupervisoryDashboard",
            element: (
              <RouteProtector allowedUsers={["isSupervisorAssignee"]}>
                <SampleInspectionSupervisoryDashboard />
              </RouteProtector>
            ),
          },
        ]
      : []),
  ],
};
